import React from 'react';
import { motion } from 'framer-motion';
export function Closing() {
  return <section className="py-24 bg-white" data-id="element-11">
      <div className="max-w-6xl mx-auto px-6" data-id="element-12">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-solventum-dark rounded-2xl p-12 text-center relative overflow-hidden" data-id="element-13">
          <div className="absolute inset-0 opacity-30" style={{
          backgroundImage: 'radial-gradient(circle at 80% 20%, rgba(5, 221, 77, 0.15) 0%, transparent 50%)'
        }} data-id="element-14" />
          <div className="relative" data-id="element-15">
            <div className="text-solventum-green text-xs font-semibold tracking-[0.25em] uppercase mb-4" data-id="element-16">
              Next Steps
            </div>
            <h3 className="font-editorial text-3xl font-bold text-white mb-4" data-id="element-17">
              From concept to pilot library
            </h3>
            <p className="text-solventum-lightTeal/80 text-lg max-w-2xl mx-auto" data-id="element-18">
              Curate the founding clinician roster, lock the first six
              restorative cases across anterior and posterior indications, and
              begin production on a pilot Solventum Clinical Peer Learnings
              series.
            </p>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="mt-16 text-center text-sm text-solventum-dark/50" data-id="element-19">
          <p data-id="element-20">
            Prepared for Solventum ·{' '}
            {new Date().toLocaleDateString('en-US', {
            month: 'long',
            day: 'numeric',
            year: 'numeric'
          })}
          </p>
        </motion.div>
      </div>
    </section>;
}